import { Table } from '@themesberg/react-bootstrap'
import React from 'react'
import { useSelector } from 'react-redux'
import PaginationComponent from '../../../../../components/Pagination'

const GamesListEdit = ({
  gameIds,
  casinoGamesData,
  setGameIds,
  page,
  limit,
  setLimit,
  setPage,
  isTenant = false,
  isEdit,
  details
}) => {
  const totalPages = Math.ceil(casinoGamesData?.count / limit)
  const { allProviders } = useSelector((state) => isTenant ? state.tenantCasino : state.superAdminCasino)

  const selectHandler = (e, casinoGameId) => {
    if (gameIds.includes('' + casinoGameId) || gameIds.includes(casinoGameId)) {
      const newObj = []
      for (const ids in gameIds) {
        if (parseInt(gameIds[ids]) !== casinoGameId) {
          newObj.push(gameIds[ids])
        }
      }
      setGameIds(newObj)
    } else {
      const newObj = []
      for (const ids in gameIds) {
        newObj.push(gameIds[ids])
      }
      newObj.push(casinoGameId)
      setGameIds(newObj)
    }
  }

  return (
    <div className='wagering-table'>
      <Table  striped responsive hover size='sm' className='text-center scrollable'>
        <thead className='thead-light'>
          <tr>
            {[
              'Game Id',
              'Name',
              'Provider'
            ].map((h) => (<th key={h}>{h}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {casinoGamesData && casinoGamesData.count > 0
            ? casinoGamesData.rows.map(({ casinoGameId, name, casinoProviderId }, idx) => {
              return (
                <tr key={`wagering-template ${casinoGameId}`}>
                  <td>
                    <input
                      className='wageering-template-checkbox'
                      type='checkbox'
                      defaultChecked={gameIds?.includes('' + casinoGameId) || gameIds?.includes(casinoGameId) || gameIds?.includes(String(casinoGameId))}
                      name={casinoGameId}
                      disabled={details}
                      onChange={(e) => { !details && selectHandler(e, casinoGameId) }}

                    />
                    {casinoGameId}
                  </td>

                  <td>{name}</td>

                  <td>{allProviders?.rows?.find(obj => obj.casinoProviderId === casinoProviderId)?.name}</td>

                </tr>
              )
            })
            : (
              <tr>
                <td colSpan={2} className='text-danger text-center'>
                  No data found
                </td>
              </tr>
              )}

        </tbody>
      </Table>
      {casinoGamesData?.count !== 0 && (
        <PaginationComponent
          page={casinoGamesData?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
        />
      )}
    </div>
  )
}

export default GamesListEdit
